import { render, staticRenderFns } from "./DialogAddPersonCollect.vue?vue&type=template&id=e4f00b4a&scoped=true&"
import script from "./DialogAddPersonCollect.vue?vue&type=script&lang=js&"
export * from "./DialogAddPersonCollect.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddPersonCollect.vue?vue&type=style&index=0&id=e4f00b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f00b4a",
  null
  
)

export default component.exports